import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50c93048"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "good-list-wrap" }
const _hoisted_2 = { class: "good-list-box" }
const _hoisted_3 = { class: "good-product" }
const _hoisted_4 = { class: "good-img" }
const _hoisted_5 = {
  key: 0,
  class: "stock-empty"
}
const _hoisted_6 = { class: "good-price" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "积分", -1))

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GoodList',
  props: {
    list: Array,
    totalScore: Number,
    customLevel: String
},
  emits: ['loadListInfo'],
  setup(__props, { emit }) {

const props = __props;



const loading = ref(false);
const finished = ref(true);
const refreshing = ref(false);
const error = ref(false);
const value = ref(1);


const onLoad = () => {
    if (refreshing.value) {
        emit('loadListInfo', [])
        refreshing.value = false;
    }
    emit('loadListInfo', 1)
    loading.value = false;
    if (props.list.length >= 20) {
        finished.value = true;
    }
};

const onRefresh = () => {
    // 清空列表数据
    finished.value = false;

    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    loading.value = true;
    onLoad();
};


// const toExchange = (id: number) => {
//     console.log(id)
// }

return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      disabled: "",
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "- 已显示全部 -",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "good-list-item",
                  key: item.id
                }, [
                  _createVNode(_component_router_link, {
                    to: '/detail?id=' + item.productCode + '&totalPoint='+ __props.totalScore +'&customLevel=' + __props.customLevel + '&unconvertible=' + ((item.points + (item.userFreightPoints??0)) > __props.totalScore ? 1 : 0)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_van_image, {
                            src: item.masterDiagramUrl
                          }, {
                            loading: _withCtx(() => [
                              _createVNode(_component_van_loading, {
                                type: "spinner",
                                size: "20"
                              })
                            ]),
                            _: 2
                          }, 1032, ["src"]),
                          (!item.remainingQuantity)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "缺货"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", {
                          class: _normalizeClass((item.points + (item.userFreightPoints??0)) > __props.totalScore ? 'good-text gray' : 'good-text')
                        }, _toDisplayString(item.productName), 3),
                        _createElementVNode("p", {
                          class: _normalizeClass((item.points + (item.userFreightPoints??0)) > __props.totalScore ? 'good-desc gray' : 'good-desc')
                        }, _toDisplayString(item.description), 3),
                        _createElementVNode("p", _hoisted_6, [
                          _createElementVNode("span", {
                            class: _normalizeClass([((item.points + (item.userFreightPoints??0)) > __props.totalScore) || !item.remainingQuantity ? 'price gray' : 'price',(item.points + (item.userFreightPoints??0)) > 99999 ? ' small' : ''])
                          }, [
                            _createTextVNode(_toDisplayString(item.points + (item.userFreightPoints??0 )), 1),
                            _hoisted_7
                          ], 2),
                          _createVNode(_component_van_button, {
                            class: _normalizeClass(((item.points + (item.userFreightPoints??0)) > __props.totalScore) || !item.remainingQuantity ? 'gray button' : 'button' ),
                            type: "primary",
                            round: "",
                            size: "mini"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString((item.points + (item.userFreightPoints??0)) > __props.totalScore ? '积分不足':'兑换'), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})